import React, { createContext, useEffect, useState } from "react";

export const CartContext = createContext(null);

const readStorage = (key, fallback) => {
  try {
    const saved = localStorage.getItem(key);
    return saved ? JSON.parse(saved) : fallback;
  } catch {
    return fallback;
  }
};

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => readStorage("tastevani-cart", readStorage("hf-cart", [])));
  const [wishlist, setWishlist] = useState(() => readStorage("tastevani-wishlist", readStorage("hf-wishlist", [])));

  useEffect(() => {
    localStorage.setItem("tastevani-cart", JSON.stringify(cartItems));
  }, [cartItems]);

  useEffect(() => {
    localStorage.setItem("tastevani-wishlist", JSON.stringify(wishlist));
  }, [wishlist]);

  const addToCart = (productId, quantity = 1, size = "", color = "") => {
    setCartItems((items) => {
      const match = items.find(
        (item) =>
          item.id === productId && item.size === size && item.color === color
      );
      if (!match) return [...items, { id: productId, size, color, quantity }];
      return items.map((item) =>
        item === match ? { ...item, quantity: item.quantity + quantity } : item
      );
    });
  };

  const removeFromCart = (productId, size = "", color = "") => {
    setCartItems((items) =>
      items.filter(
        (item) =>
          !(item.id === productId && item.size === size && item.color === color)
      )
    );
  };

  const updateQuantity = (productId, size, color, quantity) => {
    if (quantity < 1) {
      removeFromCart(productId, size, color);
      return;
    }
    setCartItems((items) =>
      items.map((item) =>
        item.id === productId && item.size === size && item.color === color
          ? { ...item, quantity }
          : item
      )
    );
  };

  const clearCart = () => setCartItems([]);

  const addToWishlist = (productId) => {
    setWishlist((items) =>
      items.includes(productId) ? items : [...items, productId]
    );
  };

  const removeFromWishlist = (productId) => {
    setWishlist((items) => items.filter((id) => id !== productId));
  };

  const toggleWishlist = (productId) => {
    setWishlist((items) =>
      items.includes(productId)
        ? items.filter((id) => id !== productId)
        : [...items, productId]
    );
  };

  const value = {
    cartItems,
    wishlist,
    addCart: addToCart,
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    addToWishlist,
    removeFromWishlist,
    toggleWishlist,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
